var React = require('react');

function ArrowNarrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","d":"M17 8l4 4m0 0l-4 4m4-4H3"}));
}

ArrowNarrowRight.defaultProps = {"fill":"none","viewBox":"0 0 24 24","stroke":"currentColor"};

module.exports = ArrowNarrowRight;

ArrowNarrowRight.default = ArrowNarrowRight;
